/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
// @ts-ignore
import type * as Types from '../../../../../packages/graphql/index';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type AddWishlistProductMutationVariables = Exact<{
  companyId: string;
  role_assignment_id: string;
  supplier_id: string;
  sku: number;
}>;


export type AddWishlistProductMutation = { addWishlistProduct: { id: string } | null };


export const AddWishlistProductDocument = /*#__PURE__*/ gql`
    mutation AddWishlistProduct($companyId: uuid!, $role_assignment_id: uuid!, $supplier_id: uuid!, $sku: Int!) {
  addWishlistProduct(
    companyId: $companyId
    role_assignment_id: $role_assignment_id
    supplier_id: $supplier_id
    sku: $sku
  ) {
    id
  }
}
    `;
export type AddWishlistProductMutationFn = Apollo.MutationFunction<AddWishlistProductMutation, AddWishlistProductMutationVariables>;

/**
 * __useAddWishlistProductMutation__
 *
 * To run a mutation, you first call `useAddWishlistProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddWishlistProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addWishlistProductMutation, { data, loading, error }] = useAddWishlistProductMutation({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      role_assignment_id: // value for 'role_assignment_id'
 *      supplier_id: // value for 'supplier_id'
 *      sku: // value for 'sku'
 *   },
 * });
 */
export function useAddWishlistProductMutation(baseOptions?: Apollo.MutationHookOptions<AddWishlistProductMutation, AddWishlistProductMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddWishlistProductMutation, AddWishlistProductMutationVariables>(AddWishlistProductDocument, options);
      }
export type AddWishlistProductMutationHookResult = ReturnType<typeof useAddWishlistProductMutation>;
export type AddWishlistProductMutationResult = Apollo.MutationResult<AddWishlistProductMutation>;
export type AddWishlistProductMutationOptions = Apollo.BaseMutationOptions<AddWishlistProductMutation, AddWishlistProductMutationVariables>;